import "./services.css"
import Service from "../service/Service"
import { useTranslation } from "../../shared/LanguageContext"

const Services = () => {
  const { t } = useTranslation()
  return (
    <div className="services-container">
      <h3 id="services">{t("nav_services")}</h3>

      <div className="services-wrapper">
        <Service />
      </div>
    </div>
  )
}

export default Services
